import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { CoverageRowData } from "./coverage-rows";

export type CoverageTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
  isRowViewed?: (row: TableRow) => boolean;
};

export function CoverageTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Coverage",
  isRowViewed,
}: CoverageTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  const columns: ColumnDef<CoverageRowData>[] = useMemo(
    () => [
      { key: "provider", header: "Provider" },
      { key: "policyId", header: "Policy ID", isHiddenOnSmallScreen: true },
      { key: "status", header: "Status" },
    ],
    []
  );

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as CoverageRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
